import { getCurrentLanguage } from 'utils/current-language'
import { SupportedLanguages, Language } from 'utils/languages'

import pl from 'i18n/languages/pl'
import en from 'i18n/languages/en'
import ru from 'i18n/languages/ru'
import ua from 'i18n/languages/ua'

const translations: Record<SupportedLanguages, Record<string, unknown>> = {
  [SupportedLanguages.pl]: pl,
  [SupportedLanguages.en]: en,
  [SupportedLanguages.ru]: ru,
  [SupportedLanguages.ua]: ua,
}

const getNestedValue = (obj: Record<string, unknown>, path: string[]): string | undefined => {
  return path.reduce<unknown>((acc, key) => {
    if (acc && typeof acc === 'object') return (acc as Record<string, unknown>)[key]
    return undefined
  }, obj) as string | undefined
}

const interpolate = (str: string, vars: Record<string, string> = {}): string => {
  return str.replace(/{{\s*(\w+)\s*}}/g, (_, key) => vars[key] ?? '')
}

export const t9n = (key: string, vars?: Record<string, string>, lang: Language = getCurrentLanguage()): string => {
  const messages = translations[lang] || translations[SupportedLanguages.pl]
  const path = key.split('.')
  const raw = getNestedValue(messages, path)
  return raw ? interpolate(raw, vars) : key
}

export const getTranslationsMap = (lang: Language = getCurrentLanguage()): Record<string, unknown> => {
  return translations[lang] || translations[SupportedLanguages.pl]
}
